import { API_PRECOG_URL_V1 } from "../../../config";
import { callWithRetry } from "../../services/callWithRetry";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";

export const precogCounterConstants = {
  GET_PRECOG_COUNTER_START: "GET_PRECOG_COUNTER_START",
  GET_PRECOG_COUNTER_SUCCESS: "GET_PRECOG_COUNTER_SUCCESS",
  GET_PRECOG_COUNTER_ERROR: "GET_PRECOG_COUNTER_ERROR",  
  CLEAR_PRECOG_COUNTER: "CLEAR_PRECOG_COUNTER" 
};
/**
 *
 * @returns contatori per da contabilizzare / contabilizzati
 */
export function getCounterPrecog() {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;    
    return new Promise((resolve, reject) => {
      dispatch({
        type: precogCounterConstants.GET_PRECOG_COUNTER_START
      });
      let request = {
        method: "GET",        
        url: `${API_PRECOG_URL_V1}/precog/count?managerId=${managerId}&itemId=${itemId}`,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
      };
      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: precogCounterConstants.GET_PRECOG_COUNTER_SUCCESS,
              payload: result.data             
            });
            resolve(result.data);
          } else {
            dispatch({
              type: precogCounterConstants.GET_PRECOG_COUNTER_ERROR        
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: precogCounterConstants.GET_PRECOG_COUNTER_ERROR        
          });
          reject();
        });
    });
  };
}

export function clearPrecogCounter() {
  return (dispatch) => {
    dispatch({
      type: precogCounterConstants.CLEAR_PRECOG_COUNTER
    });
  };
}
